import React, { useEffect } from 'react';
import Header from '../components/Header';
import { getPlanDescriptions } from '../utils/subscriptionApi';

export default function PricingPage() {
    const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
    const plans = getPlanDescriptions();

    const planOrder = [
        { key: 'FREE', name: 'Free', accent: 'text-gray-700', price: 'text-gray-900', body: 'text-gray-800', border: 'border-gray-300', bg: 'bg-gray-50' },
        { key: 'SILVER', name: 'Silver', accent: 'text-blue-700', price: 'text-blue-900', body: 'text-blue-800', border: 'border-blue-300', bg: 'bg-blue-50' },
        { key: 'GOLD', name: 'Gold', accent: 'text-yellow-700', price: 'text-yellow-900', body: 'text-yellow-800', border: 'border-yellow-400', bg: 'bg-yellow-50' },
        { key: 'PLATINUM', name: 'Platinum', accent: 'text-purple-700', price: 'text-purple-900', body: 'text-purple-800', border: 'border-purple-300', bg: 'bg-purple-50' }
    ];

    useEffect(() => {
        document.title = 'Pricing | Eternal Locker™';
    }, []);

    return (
        <>
            <Header type="small" showAccountDropdown={isLoggedIn} />
            <div className="flex justify-center w-full font-sans">
                <div className="w-full max-w-7xl p-8 space-y-6 bg-background-light shadow-2xl rounded-xl border border-accent-main">
                    <h1 className="text-3xl font-bold text-center text-accent-main">Pricing</h1>

                    <div className="flex flex-col gap-8 p-4 bg-primary-light border border-accent-main rounded-xl shadow">
                        <p className="text-lg text-justify">
                            <strong className="text-accent-main">Eternal Locker™</strong> offers simple and transparent pricing with no hidden charges.
                            Choose a plan that fits your needs and secure your digital legacy with confidence.
                        </p>

                        <div>
                            <h2 className="text-2xl font-semibold text-accent-main">Why Our Pricing Works</h2>
                            <ul className="list-disc list-inside space-y-2 text-justify">
                                <li><strong className="text-accent-main">No Hidden Fees:</strong> What you see is what you pay.</li>
                                <li><strong className="text-accent-main">Transparent Plans:</strong> Clear plan tiers for individuals and families.</li>
                                <li><strong className="text-accent-main">7-Day Money-Back:</strong> New subscriptions include a 7-day money-back guarantee.</li>
                                <li><strong className="text-accent-main">Secure Value:</strong> Advanced security, nominee continuity, and auditability included.</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="text-2xl font-semibold text-accent-main">Current Subscription Plans</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-3">
                                {planOrder.map((plan) => (
                                    <div
                                        key={plan.key}
                                        className={`rounded-lg border-2 ${plan.border} p-4 ${plan.bg} shadow-sm`}
                                    >
                                        <h3 className={`text-lg font-semibold ${plan.accent}`}>{plan.name}</h3>
                                        <p className={`text-2xl font-bold mt-2 ${plan.price}`}>{plans[plan.key]?.price || '-'}</p>
                                        <ul className={`list-disc list-inside mt-3 space-y-1 text-sm ${plan.body}`}>
                                            {(plans[plan.key]?.features || []).map((feature, index) => (
                                                <li key={index}>{feature}</li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <p className="text-sm text-justify text-text-muted">
                            To subscribe, visit the subscription page from your account dashboard.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}